import { useAppContainerContext } from '../AppContainerContext';

type ChatEmptyMessage = {
  title: string;
  subtitle: string;
};

const CHAT_EMPTY_MESSAGES: Record<string, ChatEmptyMessage> = {
  'suitability-report-edit': {
    title: 'Chat mode activated',
    subtitle:
      "Ask anything about editing this document - structure, wording, improvements and more. I'm here to help.",
  },
  default: {
    title: 'Chat with Siesta',
    subtitle:
      'Ask me anything about your client - finances, meeting prep, document questions, and more.',
  },
};

export function useChatEmptyMessage(): ChatEmptyMessage {
  const { contentMeta } = useAppContainerContext();
  const pageType = contentMeta?.pageType;

  if (pageType && CHAT_EMPTY_MESSAGES[pageType]) {
    return CHAT_EMPTY_MESSAGES[pageType];
  }
  return CHAT_EMPTY_MESSAGES.default;
}
